import RegisterField, { FieldProps } from "../register-field";
import { NumberField, NumberFieldProps } from "@/components/inputs";

export default function FormNumberField({
    name,
    registerOptions,
    ...props
}: FieldProps<NumberFieldProps>) {
    return <RegisterField name={name} disabled={props.disabled} {...registerOptions}>
        {field => <NumberField
            {...props}

            inputRef={field.ref}
            value={field.value == null ? "" : field.value}
            disabled={field.disabled}

            onValueChange={(v, s) => {
                field.handleChange(v.floatValue == null ? "" : v.floatValue);
                props.onValueChange && props.onValueChange(v, s);
            }}
            onBlur={e => {
                field.handleBlur();
                props.onBlur && props.onBlur(e);
            }}
            onKeyDown={e => {
                props.onKeyDown && props.onKeyDown(e);
                field.handleKeyDown(e);
            }}

            error={field.hasError}
            helperText={field.errorMessage}
        />}
    </RegisterField>
}